import iconAnalytics from '@/styles/images/icons/analytics.svg'
import iconCalendar from '@/styles/images/icons/calendar.svg'
import iconCandidates from '@/styles/images/icons/candidates.svg'
import iconInterviews from '@/styles/images/icons/interviews.svg'
import iconMessages from '@/styles/images/icons/messages.svg'
import iconSettings from '@/styles/images/icons/settings.svg'
import iconVacancies from '@/styles/images/icons/vacancies.svg'
import logoSafyroUrl from '@/styles/images/logo/safyro-logo.png'
import logoSafyroWhiteUrl from '@/styles/images/logo/safyro-logo-white.png'
import logoMarkUrl from '@/styles/images/logo/safyro-icon.png'

/**
 * Único punto de entrada a los assets de marca: nadie importa rutas sueltas de
 * `styles/images`, así que mover un archivo es un cambio de una línea y Vite
 * les pone hash en el build. Humania corre bajo la marca Safyro: el isotipo y
 * el logo completo son los mismos que safyro-contadores/safyro-fintrack.
 */
export const LOGO_FULL = logoSafyroUrl
export const LOGO_FULL_WHITE = logoSafyroWhiteUrl
export const LOGO_MARK = logoMarkUrl

export const BRAND_ICONS = {
  analytics: iconAnalytics,
  calendar: iconCalendar,
  candidates: iconCandidates,
  interviews: iconInterviews,
  messages: iconMessages,
  settings: iconSettings,
  vacancies: iconVacancies,
}
